import React from 'react';
import Modal from '@/components/modal/Modal';
import { Col, Row } from '@/lib/utils';
import { MediumText, RegularText } from '@/lib/Text';

type Props = {
    onClose: () => void;
    onConfirm: () => void;
};

const ModalConfirmApply = ({ onClose, onConfirm }: Props) => {
    return (
        <Modal
            onClose={onClose}
            whiteViewWidth={495}
            whiteViewHeight={295}
            borderRadius={20}
            isCloseButton={false}
            isWhiteOverFlowScroll={false}
        >
            <div className="px-[33px] pt-[17px] pb-[21px]">
                <MediumText fontSize={22} lineHeight={38} color="#3D4244" letterSpacing={-0.5}>
                    설정한 내용을 적용할까요?
                </MediumText>
                <Col className="flex flex-col mt-[28px]">
                    <RegularText fontSize={22} lineHeight={35} color="#3D4244">
                        설정한 근무 시간은 즉시
                    </RegularText>
                    <RegularText fontSize={22} lineHeight={35} color="#3D4244">
                        강사 급여 정산에 반영됩니다.
                    </RegularText>
                </Col>
                <Row className="gap-[12px] justify-end mt-[100px]">
                    <div
                        className="w-[110px] h-[41px] bg-[#F4F5F7] rounded-[12px] flex items-center justify-center cursor-pointer"
                        onClick={onClose}
                    >
                        <RegularText fontSize={16} color="#3D4244">
                            취소
                        </RegularText>
                    </div>
                    <div
                        className="w-[110px] h-[41px] bg-[#3D73DD] rounded-[12px] flex items-center justify-center cursor-pointer"
                        onClick={() => {
                            onClose();
                            onConfirm();
                        }}
                    >
                        <RegularText fontSize={16} color="#FFFFFF">
                            적용하기
                        </RegularText>
                    </div>
                </Row>
            </div>
        </Modal>
    );
};

export default ModalConfirmApply;
